import React from 'react';
import PropTypes from 'prop-types';

import styles from './PricingGrid.scss';

import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import PricingOption from './PricingOption';
import { ROUTES } from 'Settings/route-strings';

class PricingGrid extends React.PureComponent {
  constructor(props) {
    super(props);

    this.supportsGrid =
      typeof CSS !== 'undefined' && CSS.supports('display', 'grid');

    this.setLinkProps = this.setLinkProps.bind(this);
  }

  setLinkProps(option) {
    const { upgrading } = this.props;
    const newProps = {};

    if (option.id === 'custom') return newProps;

    if (this.props.selectCallback) {
      newProps.clickHandler = this.props.selectCallback;
    } else {
      const upgradePathname = this.props.hasExpiredLicense
        ? 'activation'
        : 'payment';
      newProps.route = {
        pathname: upgrading
          ? `${ROUTES.SETTINGS_SUBSCRIPTION}/${upgradePathname}`
          : ROUTES.FREE_TRIAL_ONLINE_LEARNING, // TODO switch back to FREE_TRIAL
        state: { licenseType: option.id },
      };
    }

    return newProps;
  }

  render() {
    const {
      type,
      options,
      showBanner,
      selected,
      upgrading,
      hideButtons,
      showBuyButtons,
    } = this.props;

    return (
      <div
        className={`PricingGrid PricingGrid--${type}`}
        data-option-count={options.length}
        data-supports-grid={this.supportsGrid}
      >
        {showBanner ? (
          <div className="PricingGrid__banner">
            <ConnectedFormattedMessage
              id="pricing_page.percent_off_banner"
              values={{ amount: 50 }}
            />
          </div>
        ) : null}
        <div className="PricingGrid__options">
          {options.map(option => {
            return (
              <PricingOption
                key={`option-${option.id}`}
                selected={selected === option.id}
                upgrading={upgrading}
                hideButtons={hideButtons}
                showBuyButtons={showBuyButtons}
                type={type}
                {...option}
                {...this.setLinkProps(option)}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

PricingGrid.propTypes = {
  type: PropTypes.oneOf(['pricing', 'payment']),
  options: PropTypes.array.isRequired,
  showBanner: PropTypes.bool,
  hasExpiredLicense: PropTypes.bool,
  upgrading: PropTypes.bool,
  hideButtons: PropTypes.bool,
  selected: PropTypes.string,
  selectCallback: PropTypes.func,
};

PricingGrid.defaultProps = {
  showBanner: true,
  type: 'pricing',
  hasExpiredLicense: false,
  hideButtons: false,
};

export default PricingGrid;
